import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-documents-doc-icon',
  templateUrl: './documents-doc.component.html'
})
export class DocumentsDocComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
